const types = {

  SET_LISTA_FAVORITOS: 'SET_LISTA_FAVORITOS',

  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
}

export default types
